<template>
  <div class="detail-container">
    <common-bg-image
      content="成绩复核报告"
      :informationObj="informationObj"
      :scoreObj="scoreObj"
    ></common-bg-image>
    <div :class="{ noscroll: !showAllInformation }" class="box">
      <common-information-card
        class="cards"
        :name="name"
        :showAllInformation="showAllInformation"
        :informationList="informationList"
      ></common-information-card>
      <div v-if="!showAllInformation" class="detail-nobuy">
        <answer-detail-line
          title="明细分"
          style="opacity: 0.8"
        ></answer-detail-line>
        <div class="tr">
          <span>试题序号</span>
          <span>实得分/应得分</span>
          <span>答题次数</span>
          <span>答题用时</span>
        </div>
        <div class="cover"></div>
        <div class="tip">
          <span class="desc">{{ descContent }}</span>
          <div
            v-if="showBuyRepoqButton"
            @click="buyReportClick"
            :class="{ disabled: disabled }"
            class="buy-report"
          >
            购买报告
          </div>
        </div>
      </div>
      <question-detail
        :tableDetail="tableDetail"
        :quesTypeDetail="quesTypeDetail"
        v-if="showAllInformation"
      ></question-detail>
      <img
        v-if="showAllInformation"
        @click="backTopClick"
        class="backTop"
        :src="backtop"
        alt="回到顶部"
      />
      <common-report-explain class="explain" v-if="showAllInformation">
      </common-report-explain>
    </div>
    <div v-if="showAllInformation" class="download">
      <div @click="dowloadDetailClick" class="download-detail">
        下载答题明细
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { getDate, replaceTime } from "../../js/current";
import {
  scoreDetailVisited,
  getScoreDetailReport,
  downloadAnswerDetail,
} from "../../api/index";
import backtop from "img/backtop.png";
import CommonBgImage from "../../components/commonBgImage.vue";
import CommonInformationCard from "../../components/commonInformationCard.vue";
import AnswerDetailLine from "./components/answerDetailLine";
import QuestionDetail from "../AnswerDetails/components/questionDetail.vue";
import CommonReportExplain from "../../components/commonReportExplain.vue";
export default {
  name: "answerDetails",
  components: {
    CommonBgImage,
    CommonInformationCard,
    AnswerDetailLine,
    QuestionDetail,
    CommonReportExplain,
  },
  setup() {
    // 定义store
    const store = useStore();
    const productObj = computed(() => store.state.productMsg);

    // 写死一个列表数据
    const informationList = ref([
      {
        key: "性别",
      },
      {
        key: "证件号",
      },
      {
        key: "准考证号",
      },
      {
        key: "考场",
      },
      {
        key: "考试机号",
        addClass: true,
      },
      {
        key: "开考时间",
      },
      {
        key: "结束时间",
      },
      {
        key: "答题时间",
      },
    ]);
    // 定义router
    const router = useRouter();
    const route = useRoute();

    /** 根据状态对提示文字内容和按钮样式的控制 */
    // 为购买报告增加一个动态class disabled
    let disabled = ref(false);
    // 定义描述文字在不同购买状态下不同
    let descContent = ref("");
    // 定义是否展示购买报告按钮
    let showBuyRepoqButton = ref(false);
    // 获取此考生明细报告的获取状态 未买/买未付款/已买已发货/已买未发货
    const getScoreDetailStatus = async () => {
      try {
        const { data } = await scoreDetailVisited(
          store.state.batchCode,
          store.state.perm,
          route.query.id
        );
        showBuyRepoqButton.value = true;
        if (data === -1 || data === -2 || data === -99) {
          descContent.value = "查看明细分，了解成绩详情";
        } else if (data === 0 || data === -10) {
          descContent.value = "您已购买报告，待发放";
          disabled.value = true;
          if (productObj.value.price === 0) {
            descContent.value = "您已申请报告，待发放";
            showBuyRepoqButton.value = false;
          }
        } else if (data === 1) {
          // 调用查看明细
          showAllInformation.value = true;
        }
      } catch (error) {
        console.log(error);
      }
    };

    /** 获取数据信息和明细信息 */
    // 定义card的name
    const name = ref("");
    // 定义合格状态去判断背景颜色和显示文字
    const bgImageStatus = ref("");
    // 满分和总题数信息
    const scoreObj = ref({});
    // 定义背景上的信息
    const informationObj = ref({});
    // 是否展示全部基本信息
    const showAllInformation = ref(false);
    // 明细分数据
    let tableDetail = ref([]);
    // 题型分明细数据
    let quesTypeDetail = ref([]);
    // 获取答题明细
    const getScoreDetail = async () => {
      try {
        const {
          data: { scoreExamInfo, itemDetail, sectionInfo },
        } = await getScoreDetailReport(
          store.state.batchCode,
          store.state.perm,
          route.query.id
        );
        const {
          credentialsID,
          perm,
          sex,
          status,
          candidateName,
          grade,
          examTime,
          subjectName,
          total,
          quesCount,
          examCenter,
          examRoom,
          seatNumber,
          startTime,
          endTime,
          timeUsed,
        } = scoreExamInfo;
        tableDetail.value = itemDetail;
        quesTypeDetail.value = sectionInfo;
        informationList.value[0].value = sex;
        informationList.value[1].value = credentialsID;
        informationList.value[2].value = perm;
        informationList.value[3].value = `${examCenter}${examRoom}`;
        informationList.value[4].value = seatNumber;
        informationList.value[5].value = replaceTime(startTime);
        informationList.value[6].value = replaceTime(endTime);
        informationList.value[7].value = `${timeUsed} s`;
        name.value = candidateName;
        if (status === -2) {
          bgImageStatus.value = "invalid";
        } else if (status === -1) {
          bgImageStatus.value = "no";
        } else if (status === 0) {
          bgImageStatus.value = "unsuccess";
        } else {
          bgImageStatus.value = "success";
        }
        scoreObj.value.totalScore = total;
        scoreObj.value.questionCount = quesCount;
        informationObj.value = {
          grade,
          subjectName,
          bgImageStatus: bgImageStatus,
          examTime: getDate(examTime),
        };
      } catch (error) {
        console.log(error);
      }
    };
    // 购买报告
    const buyReportClick = () => {
      // showAllInformation.value = true
      // router.push('paymentResult')
      router.push("/orderDetails");
    };
    // 回到顶部
    const backTopClick = () => {
      let top = document.getElementsByClassName("box")[0].scrollTop;
      const timeTop = setInterval(() => {
        document.getElementsByClassName("box")[0].scrollTop = top -= 80;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    };

    // 下载答题明细
    const dowloadDetailClick = async () => {
      try {
        const { data } = await downloadAnswerDetail(
          store.state.batchCode,
          store.state.perm
        );
        if (data) {
          window.location = data;
        }
      } catch (error) {
        console.error("出错了", error);
      }
    };
    onMounted(async () => {
      await getScoreDetailStatus();
      await getScoreDetail();
    });
    return {
      buyReportClick,
      informationList,
      showAllInformation,
      informationObj,
      name,
      scoreObj,
      descContent,
      disabled,
      showBuyRepoqButton,
      tableDetail,
      backtop,
      backTopClick,
      quesTypeDetail,
      dowloadDetailClick,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
@import "scss/color.scss";
.detail-container {
  overflow: hidden;
  display: flex;
  padding-bottom: 20px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .box {
    overflow-y: auto;
    margin-top: -67px;
    // height: 58%;
    flex: 1;
    .detail-nobuy {
      display: flex;
      flex: 1;
      height: 100%;
      flex-direction: column;
      position: relative;
      background-color: #fff;
      width: 702px;
      padding: 30px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 20px;
      border-radius: 16px 16px 0px 0px;
      box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.05);
      .tr {
        margin-top: 60px;
        width: 100%;
        color: #333;
        display: flex;
        justify-content: space-between;
        font-size: 28px;
      }
      .cover {
        @include flex-center;
        flex-direction: column;
        width: 702px;
        background-color: #fff;
        position: absolute;
        top: 100px;
        left: 0;
        bottom: 0;
        opacity: 0.6;
      }
      .tip {
        @include flex-center;
        flex-direction: column;
        position: absolute;
        top: 50%;
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        .desc {
          font-size: 28px;
          color: #333;
          width: 100%;
          text-align: center;
        }
        .buy-report {
          @include flex-center;
          width: 248px;
          height: 80px;
          font-size: 28px;
          color: #fff;
          background: var(--primary-color);
          border-radius: 40px;
          margin-top: 30px;
          &.disabled {
            background-color: #ccc;
            cursor: not-allowed;
            pointer-events: none;
          }
        }
      }
    }
    &.noscroll {
      overflow: hidden;
    }
    .backTop {
      position: fixed;
      bottom: 90px;
      right: 18px;
      width: 82px;
      height: 82px;
    }
  }
  .download {
    width: 100%;
    background-color: #fff;
    position: fixed;
    @include flex-center;
    height: 92px;
    bottom: 0;
    &-detail {
      @include flex-center;
      width: 702px;
      height: 72px;
      font-size: 28px;
      color: #fff;
      background: var(--primary-color);
      border-radius: 40px;
    }
  }
}
</style>
